import TiptapLink from '@tiptap/extension-link';

/**
  Tiptap overrides prosemirror to autolink when content is pasted using linkify.js.
  To fix the override, we're extending the tiptap-link and disabling the pasteRule.
**/

export const Link = TiptapLink.extend({
  addPasteRules() {
    return [];
  },
});
